import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DemoModeService } from '../../../Services/demo/demo-mode.service';

// Small always-visible ribbon while a Play Demo session is running, so it is obvious the money is
// play money. Not clickable (never blocks a game's own buttons); leaving the game ends the demo.
@Component({
  selector: 'app-demo-badge',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div *ngIf="demo.isActive()" class="demo-badge" role="status">
      <span class="dot"></span>
      <strong>DEMO</strong>
      <span class="sep">•</span>
      <span>Play money</span>
      <span class="amt">\${{ demo.balance() | number:'1.2-2' }}</span>
    </div>
  `,
  styles: [`
    .demo-badge {
      position: fixed; top: 4px; left: 50%; transform: translateX(-50%);
      z-index: 100000000; pointer-events: none;
      display: inline-flex; align-items: center; gap: 6px;
      padding: 2px 10px; border-radius: 999px;
      background: rgba(250, 204, 21, 0.92); color: #1a1200;
      font: 700 10px/1.4 system-ui, sans-serif; letter-spacing: .06em; text-transform: uppercase;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .45); white-space: nowrap;
    }
    .dot { width: 7px; height: 7px; border-radius: 50%; background: #16a34a; }
    .sep { opacity: .5; }
    .amt { font-variant-numeric: tabular-nums; }
    @media (max-width: 480px) { .demo-badge { font-size: 9px; padding: 1px 8px; } .sep, .demo-badge span:nth-child(5) { display: none; } }
  `],
})
export class DemoBadgeComponent {
  demo = inject(DemoModeService);
}
